export class FiltroMovimentoEstoqueAvulso {
  public FazendaId: number = null;
  public LocalEstoqueId: number = null;
  public DataIncio: Date = null;
  public DataFim: Date = null;
}
